import React from "react";

type Props = {
  className?: string;
  fillColor?: string;
  strokeColor?: string;
};

export const IconCheckCircle: React.FC<Props> = ({
  className = "",
  fillColor = "var(--color-accent-blue-bg)",
  strokeColor = "var(--color-accent-blue)",
}) => (
  <svg
    className={className}
    viewBox="0 0 19.5 19.5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.75 9.75C18.75 14.7206 14.7206 18.75 9.75 18.75C4.77944 18.75 0.75 14.7206 0.75 9.75C0.75 4.77944 4.77944 0.75 9.75 0.75C14.7206 0.75 18.75 4.77944 18.75 9.75Z"
      fill={fillColor}
    />
    <path
      d="M6.75 9.75L8.75 11.75L12.75 7.75M18.75 9.75C18.75 14.7206 14.7206 18.75 9.75 18.75C4.77944 18.75 0.75 14.7206 0.75 9.75C0.75 4.77944 4.77944 0.75 9.75 0.75C14.7206 0.75 18.75 4.77944 18.75 9.75Z"
      stroke={strokeColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
